module.exports = __webpack_public_path__ + "img/triangle3green.0f6b4f59.png";